import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { Broker } from '@c4/core';

import { SharedProgrammingService } from './../../common/services/shared-programming.service';
import { ProgrammingUtilsService } from '../../common/services/utils.service';
import { Device, Item } from '../../common/interfaces/item.interface';
import { ItemsService } from './../../common/services/items.service';

import { EventTypes } from '../quickstart-simple/event-types/event-types';
import { EventType } from '../quickstart-simple/event-types/event-type.interface';


export interface Category {
  name: string;
  order: number;
  types: EventType[]
}

@Injectable()
export class SelectEventService {

  installedCategories: Observable<Category[]>;
  private _installedDevices: Observable<Device[]>;

  ready: Observable<boolean>;

  private supportedCategories: Category[] = EventTypes
    .map(et => et.category)
    .reduce((acc, curr) => {
      return (acc.indexOf(curr) == -1) ? acc.concat(curr) : acc;
    }, [])
    .map(cat => {
      return {
        name: cat,
        order: [...EventTypes.filter(et => et.category == cat)][0].order || 999, /// ewww!
        types: [...EventTypes.filter(et => et.category == cat)]
      }
    });

  private supportedProxies: string[] = EventTypes.reduce((acc, curr) => {
    return acc.concat(...curr.whitelist.filter(w => !!w.proxy).map(w => w.proxy));
  }, [])

  private supportedControls: string[] = EventTypes.reduce((acc, curr) => {
    return acc.concat(...curr.whitelist.filter(w => !!w.control).map(w => w.control));
  }, [])

  private searchText: Observable<string>;

  constructor(
    private broker: Broker,
    private store: Store<any>,
    private items: ItemsService,
    private shared: SharedProgrammingService
  ) {
    this.shared.ready(false);

    this.items.ready.filter(r => !!r).subscribe(ready => {

      this._installedDevices = <Observable<Device[]>> this.items.itemsList.map(items => {
        // console.log('select-event-type: filtering items list response', items);
        return items.filter((dev: Device) => this._isSupportedControl(dev.control) || this._isSupportedProxy(dev.proxy));;
      });

      this.installedCategories = this._installedDevices.map(devices => {
        // console.log('select-event-type: filtering installed devices', devices);
        return this.supportedCategories.filter(cat => {
          // console.log('select-event-type: checking category for types in whitelist', cat);
          return cat.types.some(type => {
            // console.log('select-event-type: checking type for whitelist', type);
            return type.whitelist.some(w => {
              // console.log('select-event-type: decision time: ', devices, cat, type, w);
              return devices.map(d => d.proxy).indexOf(w.proxy) > -1 ||
                devices.map(d => d.control).indexOf(w.control) > -1;
            })
          })
        }).map(cat => {
          cat.types = cat.types.filter(type => {
            return type.whitelist.some(wl => {
              return devices.map(d => d.proxy).indexOf(wl.proxy) > -1;
            })
          });

          // console.log('returning supported category', cat);
          return cat;
        });

      });

      this.shared.ready(true);
    });

    this.ready = Observable.combineLatest(
      this.shared.isReady,
      this.items.ready,
      (a, b) => (a && b)
    );
  }

  searchTextChanged(event: any) {
    this.shared.setSearchText(event.target.value);
  }

  private _isSupportedProxy(proxy: string): boolean {
    // console.log('supported proxy? ', proxy);
    return (proxy && this.supportedProxies.indexOf(proxy) > -1);
  }

  private _isSupportedControl(control: string): boolean {
    // console.log('supported control? ', control);
    return (control && this.supportedControls.indexOf(control) > -1);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/select-event-type/select-event-type.service.ts